export enum PaymentRegistrationSuccessState {
  Registered = 'registered',
  RegisteredWithPrepayment = 'prepayment_registered',
  RegisteredAndReconciled = 'registered_and_reconciled',
  RegisteredAndReconciledWithPrepayment = 'registered_and_reconciled_with_prepayment',
}
